export const sanitizeHtml = (html: string): string => {
  if (!html) return ''
  let sanitized = html
  const regExp = new RegExp('<(script|iframe)+.*>.*</(script|iframe)+.*>', 'gi')
  sanitized = sanitized.replace(regExp, '')
  return sanitized
}
